import axios from '../services/request'

// 首页
export const Index = (data = {}) => axios.get('api/index/index',data);

// 谚语
export const Everyday = (data = {}) => axios.get('api/index/everyday',data);

// 封面图
export const getBanner = (data = {}) => axios.get('api/index/banner',data);

// 学生驾驶舱- 仪表盘总览
export const dashboard = (data = {}) => axios.get('api/cockpit/overview',data);

// 学生驾驶舱-待巩固题型
export const alerts = (data = {}) => axios.get('api/cockpit/alerts',data);

// 学生驾驶舱-雷达图
export const radar = (data = {}) => axios.get('api/cockpit/radar',data);

// 学生驾驶舱-病因分析
export const weakness = (data = {}) => axios.get('api/cockpit/weakness',data);

// 学生驾驶舱-生成专属巩固包
export const mapCreate = (data = {}) => axios.post('api/cockpit/mapCreate',data);

export const topicMap = (data = {}) => axios.get('api/cockpit/topicMap',data);

// 老师驾驶舱
export const heatmap = (data = {}) => axios.get('api/teachcockpit/heatmap',data);

export default{
    Index,
    Everyday,
    getBanner,
    dashboard,
    alerts,
    radar,
    weakness,
    topicMap,
    heatmap,
    mapCreate,
}